import InfoIcon from "@mui/icons-material/InfoOutlined";
import { Divider, Stack, Tooltip, Typography } from "@mui/material";
import { currencyFormat } from "common/numbers";

const BreakdownLine = ({ label, value, bold }) => (
  <Stack direction={"row"} justifyContent={"space-between"} gap={2}>
    <Typography variant={"caption"} fontWeight={bold ? 600 : undefined}>
      {label}
    </Typography>
    <Typography
      variant={"caption"}
      className={"tabular"}
      fontWeight={bold ? 600 : undefined}
    >
      {currencyFormat(value, 2)}
    </Typography>
  </Stack>
);

// The lines making up an amount due, for use as tooltip content
export const Breakdown = ({ breakdown }) => (
  <Stack sx={{ minWidth: "14rem" }}>
    {breakdown.lines.map((line) => (
      <BreakdownLine key={line.label} {...line} />
    ))}
    <Divider sx={{ my: 0.5, borderColor: "currentColor", opacity: 0.4 }} />
    <BreakdownLine label={"Amount due"} value={breakdown.total} bold />
    {breakdown.note && (
      <Typography variant={"caption"} sx={{ mt: 0.5 }}>
        {breakdown.note}
      </Typography>
    )}
  </Stack>
);

// An info icon whose tooltip explains how an amount due was arrived at, as built by makeBreakdown
const AmountBreakdown = ({ breakdown }) => (
  <Tooltip title={<Breakdown breakdown={breakdown} />} arrow>
    <InfoIcon
      aria-label={"Amount breakdown"}
      sx={{
        display: "block",
        fontSize: "1rem",
        // Centres the 16px icon on the 20px line of the top-aligned text beside it
        mt: "2px",
        fill: (theme) => theme.brand.gray.muted,
      }}
    />
  </Tooltip>
);

export default AmountBreakdown;
